module.exports = __webpack_public_path__ + "static/media/flikidsTurkish.2cb41e3d.jpg";